<template>
    <div
        class="p-6 bg-slate-300/30 rounded-2xl shadow-inner border-solid border-b border-t-0 border-x-0 border-white flex-col gap-4 flex"
    >
        <kiosk-radio-filter
            label="Status"
            name="status"
            :options="statusesOptions"
            v-model="filters.status"
        ></kiosk-radio-filter>
        <div>
            <div class="font-bold text-xs text-slate-700 mb-2">Target Team</div>
            <vx-selectable
                v-model="filters.target_team_id"
                placeholder="-"
                :reduce="(option) => option.value"
                :loading="loadingTargetTeams"
                :options="targetTeams"
                @search="searchTargetTeams"
                :clearable="false"
                data-test="target-teams-selectable"
            >
            </vx-selectable>
        </div>
    </div>
</template>

<script setup>
import { VxSelectable } from '@voxie/frontend-components';
import KioskRadioFilter from '~/components/kiosk/KioskRadioFilter.vue';
import { ref } from 'vue';
import { useToasted } from '~/composables/useToasted';
import { adminTeamsClient } from '~/services';
import debounce from '~/utils/debounce';

const toasted = useToasted();

const statusesOptions = [
    { label: 'All', value: undefined },
    { label: 'Draft', value: 'draft' },
    { label: 'In Progress', value: 'in_progress' },
    { label: 'Canceling', value: 'canceling' },
    { label: 'Completed', value: 'completed' },
    { label: 'Canceled', value: 'canceled' },
];

const filters = defineModel({
    default: () => ({}),
});

const targetTeams = ref([]);
const loadingTargetTeams = ref();

const searchTargetTeams = debounce((query) => {
    loadingTargetTeams.value = true;

    adminTeamsClient
        .getTeams({
            query: query,
        })
        .then((response) => {
            targetTeams.value = response.data.data.map((team) => ({
                value: team.id,
                label: `${team.id} - ${team.name}`.trim(),
            }));
        })
        .catch((e) => {
            console.error(e);
            toasted.global.platform_error();
        })
        .finally(() => {
            loadingTargetTeams.value = false;
        });
}, 300);

searchTargetTeams();
</script>
